export enum ASBVType {
  Trait = 1,
  Index = 2,
}
